"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SearchBarWrapper = require("./SearchbarWrapper");
window["LoadSearchBarWrapper"] = function (elm, params) {
    SearchBarWrapper.load(elm, params);
};
